module.exports = __webpack_public_path__ + "static/media/article-bg-left-img.e3ca466e.svg";